module.exports = __webpack_public_path__ + "static/digiryte-aa9e646def71a99896a04fab9a2fcbb7.svg";